import React, {useMemo, useState} from 'react';
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import ptBrLocale from "@fullcalendar/core/locales/pt-br";
import {FaCalendarDays} from "react-icons/fa6";
import {SCHEDULE_STATUS_META} from "../../utils/schedule-utils.js";
import "./citizen-scheduled-visit-calendar.css";

const CitizenScheduledVisitCalendar = ({rows, onEventClick}) => {
    const [visibleRange, setVisibleRange] = useState(undefined);

    const events = useMemo(() => rows.map(row => {
        const meta = SCHEDULE_STATUS_META[row.status];

        return {
            id: String(row.id),
            title: row.citizenName ?? "",
            start: row.scheduleWindowStartDt,
            end: row.scheduleWindowEndDt,
            backgroundColor: meta.background,
            borderColor: meta.dot,
            textColor: meta.color,
            extendedProps: {row},
        };
    }), [rows]);

    const monthCounts = useMemo(() => {
        const counts = {total: 0, OPEN: 0, EXECUTED: 0, CANCELED: 0};
        if (!visibleRange) return counts;

        rows.forEach(row => {
            const start = new Date(row.scheduleWindowStartDt);
            if (start >= visibleRange.start && start < visibleRange.end) {
                counts.total += 1;
                counts[row.status] += 1;
            }
        });

        return counts;
    }, [rows, visibleRange]);

    return (
        <div className={"citizen-scheduled-visit-calendar h-full flex flex-col gap-2"}>
            <div className={"flex flex-wrap items-center justify-end gap-2"}>
                <div className={"flex items-center gap-2 bg-white border border-gray-200 rounded-md shadow-sm px-3 py-1.5"}>
                    <FaCalendarDays className={"text-[#063A6C]"} size={14}/>
                    <b className={"text-sm text-gray-800"}>{monthCounts.total}</b>
                    <span className={"text-xs text-gray-500"}>no mês</span>
                </div>

                {
                    Object.entries(SCHEDULE_STATUS_META).map(([key, meta]) => (
                        <div
                            key={key}
                            className={"flex items-center gap-2 rounded-md shadow-sm px-3 py-1.5 border"}
                            style={{backgroundColor: meta.background, borderColor: `${meta.dot}55`}}
                        >
                            <span className={"w-2 h-2 rounded-full"} style={{backgroundColor: meta.dot}}/>
                            <b className={"text-sm"} style={{color: meta.color}}>{monthCounts[key]}</b>
                            <span className={"text-xs font-semibold"} style={{color: meta.color}}>{meta.label}</span>
                        </div>
                    ))
                }
            </div>

            <div className={"flex-1 min-h-0"}>
                <FullCalendar
                    plugins={[dayGridPlugin]}
                    initialView={"dayGridMonth"}
                    locale={ptBrLocale}
                    headerToolbar={{left: "today", center: "prev title next", right: ""}}
                    height={"100%"}
                    dayMaxEvents={2}
                    events={events}
                    displayEventEnd={false}
                    eventTimeFormat={{hour: "2-digit", minute: "2-digit", hour12: false}}
                    eventClick={({event}) => onEventClick?.(event.extendedProps.row)}
                    datesSet={({view}) => setVisibleRange({start: view.currentStart, end: view.currentEnd})}
                />
            </div>
        </div>
    );
};

export default CitizenScheduledVisitCalendar;
